import { useCallback } from 'react';
import { FieldValues } from 'react-hook-form';
import { generateSingleConfigString } from 'src/hooks/api/layouts/helpers';
import { useGlobalComponentsScreen } from 'src/hooks/useGlobalComponentsScreen';
import { SectionTypes } from 'src/interfaces';
import { isCurrentScreenWithDYR, lang } from 'src/utils';

import { IScreenConfigModal } from '../ScreenConfigModal';

export const useScreenConfigModal = ({
  layout,
  screenIndex,
  formMethods,
  onSaveScreenConfigModal,
  onCloseModal,
}: IScreenConfigModal) => {
  const globalComponentsScreen = useGlobalComponentsScreen(layout);
  const isDisclaimerChecked = formMethods.watch('disclaimer');

  const shouldDisableOptions = useCallback(() => {
    if (screenIndex === 1) {
      return layout!.config!.sectionTypes!.includes(SectionTypes.COD);
    }

    if (isCurrentScreenWithDYR(screenIndex + 1, globalComponentsScreen)) {
      return layout?.config?.sectionTypes?.includes(SectionTypes.DYR);
    }

    return false;
  }, [globalComponentsScreen, layout, screenIndex]);
  const validateField = useCallback(
    (name: string) => {
      if (isDisclaimerChecked && !formMethods.getValues(name)) {
        return lang.formErrorMsg.required(name);
      }

      return undefined;
    },
    [formMethods, isDisclaimerChecked],
  );
  const handleScreenConfigClose = useCallback(() => {
    formMethods.reset(undefined, { keepValues: true });
    onCloseModal();
  }, [formMethods, onCloseModal]);
  const handleSaveScreenConfigModal = (formData: FieldValues) => {
    const payload = {
      ...formData,
      id: String(layout!.id),
      index: screenIndex,
    };
    const newScreenConfigString = generateSingleConfigString(payload);

    onSaveScreenConfigModal(newScreenConfigString);
    onCloseModal();
  };

  return {
    shouldDisableOptions,
    isDisclaimerChecked,
    validateField,
    handleScreenConfigClose,
    handleSaveScreenConfigModal,
  };
};
